import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { selectWebview } from 'store/webview/webviewSlice'
import dynamic from 'next/dynamic'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'
import { useAlbums } from 'utils/api/hooks'
import { useAlbumModal } from 'utils/hooks'
import { FullscreenModal } from 'components/common/Modal'
import { getVenderWelcomeInfo } from 'utils/helpers/vender-welcome-info'

import Link from 'components/common/A'

const DynamicAlbumContent = dynamic(() =>
  import('components/pages/Album/AlbumContent')
)

const ImgRect = styled.div`
  position: relative;
  padding-top: 80%;
  margin: 0 8px;
  border-radius: 5px;
  overflow: hidden;
`
const Absolute = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const VenderLogoImg = styled.img`
  height: 100px;
  width: 100px;
  object-fit: cover;
  cursor: pointer;
`

const VenderIntro = styled(Typography)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
`

const AlbumLink = ({ venderAlbum, onAlbumClick }) => {
  return (
    <Grid item xs={4}>
      <ImgRect>
        <Absolute>
          <Link href="" onClick={(e) => onAlbumClick(e, venderAlbum)}>
            <Img src={venderAlbum?.frontCover?.image?.url} />
          </Link>
        </Absolute>
      </ImgRect>
    </Grid>
  )
}

const VenderInfo = ({ venderData, articleByLine }) => {
  const { data: venderAlbums, isLoading: isAlbumLoading } = useAlbums({
    venderId: venderData?._id,
    limit: 3,
  })
  const { logoImage, brieflyDescribeText } = getVenderWelcomeInfo(venderData)
  const displayVenderAlbums = venderAlbums?.slice?.(0, 3) || []
  const router = useRouter()

  // album content modal
  const webview = useSelector(selectWebview)
  const {
    albumModal,
    closeAlbumModal,
    onAlbumClick,
    onAlbumContentClose,
  } = useAlbumModal('/article', router, {
    webview,
    nativeHeaderHandler: () => null,
  })

  return (
    <Grid container mb={14}>
      <Typography mb={6} fontWeight="fontWeightBold">
        文章作者
      </Typography>
      <Grid item xs={12}>
        <Grid item display="flex" justifyContent="center" xs={12} mb={2}>
          <Box
            display="flex"
            justifyContent="center"
            sx={{
              borderRadius: '50%',
              overflow: 'hidden',
            }}
          >
            <VenderLogoImg
              alt=""
              src={logoImage?.url || '/img/img_headshot_default.png'}
              onClick={
                venderData?.introductionInfo?.isVisible
                  ? () => {
                      router.push(`/vender/${venderData?.urlId}`)
                    }
                  : null
              }
              style={{
                cursor: venderData?.introductionInfo?.isVisible
                  ? 'pointer'
                  : 'default',
              }}
            />
          </Box>
        </Grid>
        <Grid item display="flex" justifyContent="center" xs={12} mb={3}>
          <Typography sx={{ fontSize: '24px' }}>
            <Box fontWeight="fontWeightBold">
              {venderData?.introductionInfo?.isVisible ? (
                <Link href={`/vender/${venderData?.urlId}`} $origin>
                  {venderData?.shortname}
                </Link>
              ) : (
                articleByLine
              )}
            </Box>
          </Typography>
        </Grid>
        <Grid item display="flex" justifyContent="center" xs={12} mb={4}>
          <VenderIntro variant="caption" color="textSecondary">
            {brieflyDescribeText}
          </VenderIntro>
        </Grid>
      </Grid>
      <Grid item display="flex" justifyContent="start" xs={12}>
        {venderData &&
          !!displayVenderAlbums.length &&
          displayVenderAlbums?.map((venderAlbum) => {
            return (
              <AlbumLink
                venderAlbum={venderAlbum}
                onAlbumClick={onAlbumClick}
              />
            )
          })}
      </Grid>

      {router?.isReady && albumModal.open && (
        <FullscreenModal open={albumModal.open} onClose={closeAlbumModal}>
          <DynamicAlbumContent
            onClose={onAlbumContentClose}
            closeModal={closeAlbumModal}
            fallbackData={albumModal.fallbackData}
          />
        </FullscreenModal>
      )}
    </Grid>
  )
}

export default VenderInfo
